<ng-container *transloco="let t">
  <z-broadcast-debug></z-broadcast-debug>
  <div class="login-body">
    <div class="login-background">
      <div class="layer-1" [ngStyle]="layer1Style$ | async"></div>
      <div class="layer-2" [ngStyle]="layer2Style$ | async"></div>
    </div>
    <div class="login-container">
      <div
        class="login-panel shadow-7"
        [class.login-panel-expanded]="loading$ | async"
        (document:keydown.control.shift.z)="automaticLogin()"
        (keydown.enter)="login()"
        [formGroup]="form"
      >
        <div #logo class="logo">
          <z-logo></z-logo>
        </div>

        <div class="username">
          <span class="icon-left">
            <i class="fad fa-user"></i>
            <input
              zTextInput
              formControlName="username"
              placeholder="{{ t('auth.login.username') }}"
              [uppercase]="true"
              [displayValidationErrors]="false"
            />
          </span>
        </div>

        <div class="field password">
          <span class="p-input-icon-left">
            <i class="fad fa-key"></i>
            <input
              zTextInput
              pPassword
              type="password"
              formControlName="password"
              placeholder="{{ t('auth.login.password') }}"
              [uppercase]="false"
              [feedback]="false"
              [displayValidationErrors]="false"
            />
          </span>
        </div>

        <div class="login-controls">
          <button
            pButton
            label="{{ t('auth.login.login_button') }}"
            icon="fad fa-sign-in"
            iconPos="left"
            class="p-button p-button-warning login-button"
            (click)="login()"
            [disabled]="loading$ | async"
            [class.login-button-disabled]="loading$ | async"
          ></button>
        </div>

        <div class="login-spinner" [class.login-spinner-display]="loading$ | async">
          <svg viewBox="0 0 100 25">
            <g class="blue-dot-2">
              <circle class="zethcon-blue blue-dot-1" cx="30%" cy="50%" r="5" />
            </g>

            <g class="grey-dot-2">
              <circle class="zethcon-grey grey-dot-1" cx="50%" cy="50%" r="5" />
            </g>

            <g class="orange-dot-2">
              <circle class="zethcon-orange orange-dot-1" cx="70%" cy="50%" r="5" />
            </g>
          </svg>
        </div>

        <div class="login-copyright">
          <div><z-version></z-version></div>
          <div><z-copyright [displayLicenseMessage]="false"></z-copyright></div>
        </div>
      </div>
    </div>
  </div>

  <z-notifications></z-notifications>

  <p-contextMenu
    #contextMenu
    *ngIf="!environmentService.environment.production"
    [model]="developerService.contextMenuItems$ | async"
    [target]="logo"
    appendTo="body"
  ></p-contextMenu>
</ng-container>
